// Copyright © 2019-2026 Focal Systems. All rights reserved.

/**
 * The page an authenticated user lands on by default — used for the bare-root
 * redirect, the post-login fallback, and to decide when a `?redirect` param on
 * the login URL is redundant (it points at this page with no query anyway).
 *
 * Home is open to every signed-in user (no page permission), so landing here
 * never bounces someone onto an access-denied page.
 */
export const DEFAULT_AUTHENTICATED_PATH = "/home" as const;
